import ColorThief from 'color-thief-browser';
import { useQuery } from '@tanstack/react-query';
import { QueryKey } from '@/application/queryKeys';

const colorThief = new ColorThief();

const getImage = (path: string): Promise<HTMLImageElement | false> =>
  new Promise((resolve) => {
    const img = new Image(10, 10);
    img.src = path;
    img.crossOrigin = 'anonymous';
    img.onload = () => resolve(img);
    img.onerror = () => resolve(false);
  });

const useImageColor = (img?: string) => {
  return useQuery(
    [QueryKey.COLOR, img],
    async () => {
      if (img) {
        const image = await getImage(img);

        if (image) {
          const [r, g, b] = colorThief.getColor(image);
          return {
            rgb: `rgb(${r},${g},${b})`,
            rgba: `rgba(${r},${g},${b},1)`,
            raw: [r, g, b],
          };
        }
      }
      return null;
    },
    {
      enabled: !!img,
      staleTime: Infinity,
      cacheTime: Infinity,
      refetchInterval: false,
    }
  );
};

export default useImageColor;
